import { createAPI } from '@common'

/**
 * 创客贴相关接口
 */
const ChuangKitAction = {
  // 获取签名
  getCreativeParamSign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0dsfbujwfQbsbn', 'get', config),
  // 根据图片地址保存图片
  saveWithUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0tbwfXjuiVsm', 'post', config),
  // 获取场景
  getCustomConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0dsfbujwf0dvtupnDpogjh', 'get', config),
  // 个人设计
  getUserDesigns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0dsfbujwf0vtfsEftjhot', 'get', config)
}
export default ChuangKitAction
